import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import axios from "axios";
import { debounce } from "lodash";

import { LoadingIcon, InLineLoading } from "../../Common/Loading_Icon";
import { registrationCheckmark, CheckIcon } from "../../Common/Buttons/Icons";
import { Trans } from "react-i18next";

class Verification extends Component {
  constructor(props) {
    super(props);

    this.submitPhone = debounce(this.submitPhone.bind(this), 500);
    this.submitVerification = this.submitVerification.bind(this);
    this.pasteVerification = this.pasteVerification.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.mobilePhoneChange = this.mobilePhoneChange.bind(this);
    this.phoneChange = this.phoneChange.bind(this);
    this.formatNumber = this.formatNumber.bind(this);
    this.toggleFocus = this.toggleFocus.bind(this);
    this.cancelPhoneEdit = this.cancelPhoneEdit.bind(this);
    this.editNumber = this.editNumber.bind(this);

    this.state = {
      loading: true,
      number_editable: false,
      original_phone: null,
      verified: false,
      phone_form: { country: "1", phone: "" },
      confirms: { phone: false, activation: false },
      errors: { country: false, phone: false, activation: false },
      activation_loading: false,
      phone_loading: false,
      colours: { red: "#D55656", green: "#42B53A", grey: "#919EAB" },
      email: "",
    };
  }

  componentDidMount() {
    document.title = "Profile Settings - FleetXPress";
    var self = this;

    axios
      .get("/ajax/phone/checkValidated")
      .then(function(response) {
        self.setState({
          loading: false,
          verified: response?.data.verified,
          original_phone: response?.data.phone,
          number_editable: !response?.data.phone_found,
          phone_form: { country: "1", phone: response?.data.phone },
        });
      })
      .catch(function(error) {});

    this.setState({
      email: this.props.userSession.user.email,
    });
  }

  cancelPhoneEdit() {
    this.setState({
      number_editable: this.state.original_phone.length === 0,
      phone_form: { country: "1", phone: this.state.original_phone },
      confirms: { phone: false, activation: false },
      errors: { country: false, phone: false, activation: false },
      activation_loading: false,
      phone_loading: false,
      verified: this.state.original_phone.length === 10,
    });
  }

  submitPhone() {
    var self = this;

    if (this.state.confirms.activation) {
      showStatusMsg(
        "You have already validated your phone number. Please press Next to complete the survey process.",
        "success"
      );
    } else if (
      this.state.phone_form.phone.length < 10 ||
      !/^\d+$/.test(this.state.phone_form.phone)
    ) {
      var errors = this.state.errors;
      errors["phone"] = true;
      this.setState({
        errors: errors,
      });
    } else if (
      this.state.phone_form.phone === this.state.original_phone &&
      this.state.verified
    ) {
      showStatusMsg(
        "This phone number is the same as your original phone number. Please submit a new number to validate.",
        "error"
      );
    } else {
      this.setState({
        phone_loading: true,
      });

      axios
        .post("/ajax/phone/number", {
          country: this.state.phone_form.country,
          phone: this.state.phone_form.phone,
        })
        .then(function(response) {
          if (response?.data.status === "pending") {
            self.setState({
              errors: { country: false, phone: false, activation: false },
              confirms: { phone: true, activation: false },
              activation_loading: false,
              phone_loading: false,
            });
          } else {
            self.setState({
              errors: { country: true, phone: false, activation: false },
              confirms: { phone: false, activation: false },
              activation_loading: false,
              phone_loading: false,
            });
          }
        })
        .catch(function(error) {
          self.setState({
            errors: { country: true, phone: false, activation: false },
            activation_loading: false,
          });
        });
    }
  }

  submitVerification() {
    var self = this;
    var verification = "";
    for (var i = 0; i < 6; i++) {
      verification += document.getElementById("validation-" + i).value;
    }

    if (this.state.phone_form.phone.length < 10 && this.state.confirms.phone) {
      var errors = this.state.errors;
      errors["phone"] = true;
      this.setState({
        errors: errors,
      });
    } else if (verification.length < 6) {
      var errors = this.state.errors;
      errors["activation"] = true;
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        activation_loading: true,
      });

      axios
        .post("/ajax/phone/verify", {
          country: this.state.phone_form.country,
          phone: this.state.phone_form.phone,
          verification: verification,
        })
        .then(function(response) {
          if (response?.data.status === "approved" && response?.data.valid) {
            self.setState({
              original_phone: self.state.phone_form.phone,
              number_editable: false,
              activation_loading: false,
              confirms: { phone: false, activation: false },
              errors: { country: false, phone: false, activation: false },
              verified: true,
            });

            showStatusMsg(
              "Your phone number has been successfully validated",
              "success"
            );
          } else {
            self.setState({
              errors: { country: false, phone: false, activation: true },
              confirms: { phone: true, activation: false },
              activation_loading: false,
            });
          }
        })
        .catch(function(error) {
          self.setState({
            errors: { country: false, phone: false, activation: true },
            activation_loading: false,
          });
        });
    }
  }

  pasteVerification(e) {}

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    var phone_form = this.state.phone_form;
    phone_form[name] = value;

    this.setState({
      phone_form: phone_form,
    });
  }

  mobilePhoneChange() {
    this.setState({
      errors: { country: false, phone: false, activation: false },
      confirms: { phone: false, activation: false },
      activation_loading: false,
    });

    for (var i = 0; i < 6; i++) {
      if (document.getElementById("validation-" + i)) {
        document.getElementById("validation-" + i).value = "";
      }
    }

    var phone = document.getElementById("phone_input_mobile").value;
    phone = phone.replace(/\D/g, "");
    document.getElementById("phone_input_mobile").value = phone;

    var phone_form = this.state.phone_form;
    phone_form["phone"] = phone;

    this.setState({
      phone_form: phone_form,
    });
  }

  phoneChange(event) {
    event.preventDefault();
    this.setState({
      errors: { country: false, phone: false, activation: false },
      confirms: { phone: false, activation: false },
      activation_loading: false,
    });
    for (var i = 0; i < 6; i++) {
      if (document.getElementById("validation-" + i)) {
        document.getElementById("validation-" + i).value = "";
      }
    }

    var current_phone = document.getElementById("phone_input").innerHTML;
    current_phone = current_phone.replace(/\D/g, "");

    if (current_phone.length < 10) {
      if (isFinite(event.key)) {
        //Add number
        current_phone += event.key;
      }
    }

    if (event.keyCode === 8 || event.keyCode === 46) {
      //Backspace
      current_phone = current_phone.substring(0, current_phone.length - 1);
    }

    var phone_form = this.state.phone_form;
    phone_form["phone"] = current_phone;

    this.setState({
      phone_form: phone_form,
    });
  }

  formatNumber(phone) {
    var phone_array = [<span className="phone_extra">(</span>];
    for (var i = 0; i < phone.length; i++) {
      if (i === 3) {
        phone_array.push(<span className="phone_extra">) </span>);
      }

      if (i === 6) {
        phone_array.push(<span className="phone_extra"> - </span>);
      }

      if (!this.state.number_editable && i < 7) {
        phone_array.push(<span className="phone_num">*</span>);
      } else {
        phone_array.push(<span className="phone_num">{phone[i]}</span>);
      }
    }

    while (phone_array.length < 13) {
      if (phone_array.length === 4) {
        phone_array.push(<span className="phone_extra">) </span>);
      }

      if (phone_array.length === 8) {
        phone_array.push(<span className="phone_extra"> - </span>);
      }

      phone_array.push(<span className="phone_underscore"> _ </span>);
    }

    return <>{phone_array}</>;
  }

  editNumber() {
    this.setState({
      number_editable: true,
      phone_form: { country: "1", phone: "" },
      verified: false,
    });
  }

  handleActivationInput(event, index) {
    event.preventDefault();
    var self = this;

    if (event.keyCode === 8 || event.keyCode === 46) {
      document.getElementById("validation-" + index).value = "";
      if (index > 0) {
        document.getElementById("validation-" + (index - 1)).focus();
      }
    } else if (event.keyCode !== 13 && isFinite(event.key)) {
      document.getElementById("validation-" + index).value = event.key;

      if (index < 5) {
        document.getElementById("validation-" + (index + 1)).focus();
      }
    } else if (event.keyCode == 229) {
      // android chrome only
      if (index < 5) {
        setTimeout(function() {
          document.getElementById("validation-" + (index + 1)).focus();
        }, 50);
      } else {
        setTimeout(function() {
          self.submitVerification();
        }, 100);
      }
    }
  }

  toggleFocus(focus) {
    this.setState({
      focus,
    });
  }

  render() {
    return (
      <div>
        <div className="number_container sectioned">
          <div className="settings_header">
            <div className="left_header"><Trans>Mobile Number</Trans></div>
            {!this.state.number_editable && !this.state.loading ? (
              <div className="right_header link" onClick={this.editNumber}>
                <Trans>Edit phone number</Trans>
              </div>
            ) : null}
          </div>

          {this.state.loading ? (
            <div
              style={{
                position: "relative",
                display: "flex",
                width: "100%",
                height: "150px",
              }}
            >
              <span style={{ margin: "auto" }}>{InLineLoading()}</span>
            </div>
          ) : (
            <div className="settings_subarea">
              <div className="settings_helper_text">
                <Trans>
                  Providing your phone number allows us to get in touch with you
                  if plans change. It also helps stakeholders to verify your
                  identity with bookings.
                </Trans>
              </div>
              <div className="settings_verified_indicator">
                {this.state.verified ? (
                  <>
                    <span className="settings_verified_text success">
                      <Trans>Mobile number has been verified</Trans>
                    </span>{" "}
                    <span className="settings_verified_icon">
                      {registrationCheckmark(this.state.colours.green)}
                    </span>
                  </>
                ) : (
                  <span className="settings_verified_text error">
                    <Trans>Mobile number has not been verified</Trans>
                  </span>
                )}
              </div>
              <div className="settings_phone_input_container">
                <div className="verification-field">
                  <div className="verification-select">
                    <select
                      style={{ marginBottom: "0" }}
                      className={
                        this.state.errors.country ? "verification-error" : ""
                      }
                    >
                      <option value="1" selected>
                        🇨🇦 +1 CA
                      </option>
                      <option value="1">🇺🇸 +1 US</option>
                    </select>
                    {this.state.errors.country ? (
                      <span
                        style={{
                          margin: "5px 0 0 0",
                          fontSize: "8px",
                          color: "red",
                          display: "ruby-text",
                        }}
                      >
                        *<Trans>This number is invalid. Please try another number.</Trans>.
                      </span>
                    ) : null}
                  </div>
                </div>
                <div
                  className="verification-field"
                  style={{ marginLeft: "20px" }}
                >
                  <div
                    contentEditable={this.state.number_editable}
                    id="phone_input"
                    className={
                      "desktop verification-input" +
                      (this.state.errors.phone ? " verification-error" : "")
                    }
                    onKeyDown={this.phoneChange}
                  >
                    {this.formatNumber(this.state.phone_form.phone)}
                  </div>
                  <input
                    id="phone_input_mobile"
                    onChange={this.mobilePhoneChange}
                    className={
                      "mobile verification-input" +
                      (this.state.errors.phone ? " verification-error" : "")
                    }
                    type="tel"
                    placeholder="(_ _ _)  _ _ _ - _ _ _ _"
                  />
                  {this.state.errors.phone ? (
                    <span
                      style={{
                        margin: "5px 0 0 0",
                        fontSize: "8px",
                        color: "red",
                        display: "ruby-text",
                      }}
                    >
                      *<Trans>This field is required</Trans>.
                    </span>
                  ) : null}
                </div>
              </div>
              {this.state.number_editable && !this.state.confirms.phone ? (
                <div className="settings_verify_actions">
                  {this.state.phone_form.phone.length > 0 ? (
                    <div
                      className="button secondary px-32 mr-16"
                      onClick={this.cancelPhoneEdit}
                    >
                      <Trans>Cancel</Trans>
                    </div>
                  ) : null}
                  <div
                    className="button primary px-32"
                    onClick={this.submitPhone}
                  >
                    <Trans>Verify</Trans>
                  </div>
                </div>
              ) : null}
              {this.state.confirms.phone ? (
                <div className="settings_verify_container">
                  <div className="settings_verify_help">
                    <Trans>A 6-digit Activation Code has been sent.</Trans>
                  </div>
                  <div className="settings_verify_help mt-12">
                    <Trans>Please enter it below.</Trans>
                  </div>
                  <div
                    className="verification-label"
                    style={{ marginBottom: "5px" }}
                  >
                    <Trans>Activation Code</Trans>
                  </div>

                  <div className="verification-activation">
                    {Array(6)
                      .fill()
                      .map((object, index) => {
                        return (
                          <input
                            id={"validation-" + index}
                            disabled={!this.state.confirms.phone}
                            className={
                              this.state.confirms.activation
                                ? "verification-success"
                                : this.state.errors.activation
                                ? "verification-error"
                                : this.state.focus
                                ? "active-input"
                                : ""
                            }
                            onKeyDown={(e) =>
                              this.handleActivationInput(e, index)
                            }
                            onFocus={() => this.toggleFocus(true)}
                            onBlur={() => this.toggleFocus(false)}
                            maxLength="1"
                            onPaste={this.pasteVerification}
                          />
                        );
                      })}
                    {this.state.confirms.activation ? (
                      <span style={{ margin: "auto 10px" }}>
                        {CheckIcon("fill-green")}
                      </span>
                    ) : null}
                    {this.state.activation_loading ? InLineLoading() : null}
                  </div>
                  {this.state.errors.activation ? (
                    <span
                      style={{
                        margin: "5px 0 0 0",
                        fontSize: "8px",
                        color: "red",
                        display: "ruby-text",
                      }}
                    >
                      *<Trans>Activation code is invalid</Trans>.
                    </span>
                  ) : null}
                  <div className="verification-actions mt-16">
                    <div
                      className="button secondary px-32 mr-16"
                      onClick={this.cancelPhoneEdit}
                    >
                      <Trans>Cancel</Trans>
                    </div>
                    <div
                      className="button primary px-32"
                      onClick={this.submitVerification}
                    >
                      <Trans>Verify</Trans>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
        <div className="email_container">
          <div className="settings_header">
            <div className="left_header"><Trans>Email Address</Trans></div>
          </div>
          <div className="settings_subarea">
            <div className="settings_helper_text">
              <Trans>
                Providing your phone number allows us to get in touch with you if
                plans change. It also helps stakeholders to verify your identity
                with bookings.
              </Trans>
            </div>
            <div className="settings_verified_indicator">
              <span className="settings_verified_text success">
                <Trans>Email has been verified</Trans>
              </span>{" "}
              <span className="settings_verified_icon">
                {registrationCheckmark(this.state.colours.green)}
              </span>
            </div>
            <div className="settings_phone_input_container">
              <input
                className="settings_input"
                disabled={true}
                value={this.state.email}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  userSession: store.userSession,
});

export default connect(mapStateToProps)(Verification);
